import template from './vd-upsell-secondary.html'

export default {
  bindings: {
    header: '<',
    body: '<',
    features: '<',
  },
  transclude: {
    action: 'vdUpsellAction',
    image: 'vdUpsellImage',
  },
  template,
}
